
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import image1 from "../img/tradly/enjoei-homepage.png"
import image2 from "../img/tradly/enjoei-promobanner1-1024x307.png"
import image3 from "../img/tradly/enjoei-promobanners-1024x284.png"
import image4 from "../img/tradly/enjoei-collectionwidget1-1024x404.png"
import image5 from "../img/tradly/enjoei-collectionwidget3-1-1024x348.png"
import image6 from "../img/tradly/enjoei-collectionwidget4-1024x413.png"
import image7 from "../img/tradly/enjoei-collectionwidget2-1024x408.png"
import image8 from "../img/tradly/enjoei-collectionwidget2-1024x408.png"
import image9 from "../img/tradly/enjoei-advancedcategory2-1024x384.png"
import image10 from "../img/tradly/enjoei-advancedcategory-1024x369.png"
import image11 from "../img/tradly/enjoei-attributes-custom-1024x775.png"
import image12 from "../img/tradly/enjoei-reviews-attributes-1024x526.png"
 
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Building and launching like Enjoei in Brazil - Used products online marketplace and app",
  "date": "2021-02-21"
};
const slug = 'building-and-launching-like-enjoei-in-brazil-used-products-online-marketplace-and-app';
const tableOfContents = [{
  "title": "Promo Banners like Enjoei",
  "slug": "promo-banners-like-enjoei",
  "children": []
}, {
  "title": "Custom Flexible Collection Widgets like Enjoei",
  "slug": "custom-flexible-collection-widgets-like-enjoei",
  "children": []
}, {
  "title": "Advanced categories/catalogue like Enjoei",
  "slug": "advanced-categories-catalogue-like-enjoei",
  "children": []
}, {
  "title": "Listing Attributs Configuration like Enjoei",
  "slug": "listing-attributs-configuration-like-enjoei",
  "children": []
}, {
  "title": "Store Ratings and Reviews like Enjoei",
  "slug": "store-ratings-and-reviews-like-enjoei",
  "children": []
}, {
  "title": "Further Readings",
  "slug": "further-readings",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p><em parentName="p">{`Enjoei`}</em>{` is an online marketplace for used products in Brazil. Its platform allows buyers and sellers to communicate directly and negotiate to get used products. If you are looking to build and launch an app like Enjoei, here we have shared the building block of Gotrendier. You can use TradlyPlatform API or full stack solution to get the same features and launch your app without much risks.`}</p>
    <img src={image1} alt="" />
    <_Heading level={2} id={"promo-banners-like-enjoei"} nextElement={{
      "type": "jsx"
    }}>Promo Banners like Enjoei</_Heading>
    <img src={image2} alt="" />
    <img src={image3} alt="" />
    <_Heading level={2} id={"custom-flexible-collection-widgets-like-enjoei"} nextElement={{
      "type": "jsx"
    }}>Custom Flexible Collection Widgets like Enjoei</_Heading>
    <img src={image4} alt="" />
    <img src={image5} alt="" />
    <img src={image6} alt="" />
    <img src={image7} alt="" />
    <img src={image8} alt="" />
    <_Heading level={2} id={"advanced-categories-catalogue-like-enjoei"} nextElement={{
      "type": "jsx"
    }}>Advanced categories/catalogue like Enjoei</_Heading>
    <img src={image9} alt="" />
    <img src={image10} alt="" />
    <_Heading level={2} id={"listing-attributs-configuration-like-enjoei"} nextElement={{
      "type": "jsx"
    }}>Listing Attributs Configuration like Enjoei</_Heading>
    <img src={image11} alt="" />
    <_Heading level={2} id={"store-ratings-and-reviews-like-enjoei"} nextElement={{
      "type": "jsx"
    }}>Store Ratings and Reviews like Enjoei</_Heading>
    <img src={image12} alt="" />
    <_Heading level={2} id={"further-readings"} nextElement={{
      "type": "export"
    }}>Further Readings</_Heading>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
